import { SectionProps } from './Types'
import Styles from './Section.module.scss'

const Section = ({ children, padding, gap }: SectionProps) => {
  return (
    <div className={Styles.section} style={{ padding, gap }}>
      {children}
    </div>
  )
}

export { Section }
